/**
 * Schedule consultation API — Lambda Function URL (POST, no auth).
 * URL is injected at build time via REACT_APP_SUBMIT_SCHEDULE_URL (see sst.config.ts).
 */

const SUBMIT_SCHEDULE_URL = process.env.REACT_APP_SUBMIT_SCHEDULE_URL;

if (!SUBMIT_SCHEDULE_URL && process.env.NODE_ENV !== 'production') {
  console.warn('REACT_APP_SUBMIT_SCHEDULE_URL is not set. Schedule submissions will fail.');
}

/**
 * Submit a scheduled consultation request.
 * @param {Object} payload - { name, email, phone, reason, scheduledDate, scheduledTime, consentSms, agreeTerms, agreePrivacy, consentedAt }
 * @returns {Promise<{ success: boolean, message: string }>}
 */
export async function submitScheduleConsultation(payload) {
  if (!SUBMIT_SCHEDULE_URL) {
    throw new Error('Scheduling is not configured. Please call us directly.');
  }

  const response = await fetch(SUBMIT_SCHEDULE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || 'Unable to schedule your consultation. Please try again or call us.');
  }

  return data;
}
